import { camelCaseObjectToSnakeCase } from '../../utils/convert-case';
import interpolateStringToTemplate from '../../utils/interpolate-string-to-template';

const compileCustomTemplate = (customTemplate, { variables }) =>
  interpolateStringToTemplate(customTemplate, camelCaseObjectToSnakeCase(variables));

export default compileCustomTemplate;
